import { XCircle } from "lucide-react";
import { Logo } from "@/components/site/Reveal";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-obsidian text-chalk font-sans flex items-center justify-center px-5">
      <div className="max-w-md w-full text-center rounded-3xl border border-white/10 bg-coal p-9" data-testid="payment-cancel-page">
        <div className="flex justify-center mb-8"><Logo size={44} /></div>
        <XCircle size={48} className="mx-auto text-ember" />
        <h1 className="mt-6 font-heading text-2xl font-extrabold uppercase">Paiement interrompu</h1>
        <p className="mt-4 text-sm sm:text-base text-slate-300 leading-relaxed">
          Aucun montant n'a été débité. Vous pouvez reprendre votre souscription quand vous
          le souhaitez — ou échanger d'abord avec Yassine lors du diagnostic offert.
        </p>
        <a
          href="/#tarifs"
          data-testid="payment-cancel-back-link"
          className="mt-8 inline-flex items-center justify-center rounded-full bg-ember hover:bg-emberdark px-7 py-3.5 text-xs font-bold uppercase tracking-wide transition-colors duration-200"
        >
          Revenir aux formules
        </a>
      </div>
    </div>
  );
}
